"use strict";

import angular from "angular";
/**
 * @component nuLargeEmptyMessage
 * O <nu-large-empty-message> è um componente que é usado para mostrar uma menssage e também uma dica quando uma pesquisa não retorna sucesso
 * @this { scope.icon: "@" } Ícone
 * @this { scope.hint: "@" } Mensagem de dica abaixo do ícone
 * @this { scope.message: "@" } Mensagem abaixo da dica em font maior
 * @this { scope.button: "=" } Botão abaixo da descrição
 */

import template from "./large-empty-message.component.html";
import "./themes/large-empty-message.component.scss";
import "./themes/large-empty-message-dark.component.scss";

const name = "nuLargeEmptyMessage";
const def = {
    bindings: {
        button: "=",
        secondButton: "=",
        hint: "@",
        img: "@",
        message: "@",
        isBusinessman: "<",
        isGroup: "<"
    },
    controllerAs: "largeEmptyMessage",
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
